import * as fns from 'date-fns';
import { dateFormatRegionMap } from '../../constants/dateFormat';

const labelCallback =
    ({ format = 'MM/dd/yyyy' }) =>
    context => {
        const yLabel = context.parsed.y;
        const label = context.label;
        const value = fns.format(yLabel, format);
        const formattedLabel = `${label}: ${value}`;
        return formattedLabel;
    };

const axisCallback =
    ({ labels, format = 'MMM dd' }) =>
    (_, index) => {
        if (!labels) return null;
        const value = labels[index];
        return fns.format(value, format);
    };

const dateConfig = ({ labels, locale }) => {
    const dateRegion =
        locale || localStorage.getItem('mvc-date-locale') || 'en-US';
    const format = dateFormatRegionMap[dateRegion];

    return {
        scales: {
            y: {
                ticks: {
                    // Include a dollar sign in the ticks
                    callback: axisCallback({
                        labels,
                        format: format.axis,
                    }),
                },
            },
        },
        plugins: {
            tooltip: {
                callbacks: {
                    label: labelCallback({
                        format: format.short,
                    }),
                },
            },
        },
    };
};

export default dateConfig;
